var _defs, _path, _path2, _polygon, _line, _line2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrackingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#0b1320;stroke-linecap:round;stroke-linejoin:round;}.cls-2{fill:#0b1320;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,28.05a3,3,0,0,1-3,3H4a3,3,0,0,1-3-3V10.82H35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,5H32a3,3,0,0,1,3,3v2.86a0,0,0,0,1,0,0H1a0,0,0,0,1,0,0V8A3,3,0,0,1,4,5Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.92 14.98 17.7 14.98 17.7 19.93 30.77 19.93 30.77 14.98 24.92 14.98"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.71,
    y1: 23.5,
    x2: 30.78,
    y2: 23.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.71,
    y1: 27.01,
    x2: 24.24,
    y2: 27.01
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6,8.06a.74.74,0,0,1-.74.74h0a.74.74,0,0,1-.74-.74h0a.74.74,0,0,1,.74-.74h0A.74.74,0,0,1,6,8.06Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.91,8.06a.74.74,0,0,1-.74.74h0a.74.74,0,0,1-.74-.74h0a.74.74,0,0,1,.74-.74h0a.74.74,0,0,1,.74.74Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.87,8.06a.74.74,0,0,1-.74.74h0a.74.74,0,0,1-.74-.74h0a.74.74,0,0,1,.74-.74h0a.74.74,0,0,1,.74.74Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22,17.45a.74.74,0,0,1-.74.74h0a.74.74,0,0,1-.74-.74h0a.74.74,0,0,1,.74-.73h0a.74.74,0,0,1,.74.73Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,17.45a.74.74,0,0,1-.74.74h0a.74.74,0,0,1-.74-.74h0a.74.74,0,0,1,.74-.73h0a.74.74,0,0,1,.74.73Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.94,17.45a.74.74,0,0,1-.74.74h0a.74.74,0,0,1-.74-.74h0a.74.74,0,0,1,.74-.73h0a.74.74,0,0,1,.74.73Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.91,26a5,5,0,0,1,0-10,5,5,0,0,1,0,10Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 8.91,
    cy: 19.93,
    rx: 1.97,
    ry: 2.01
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.91,26a4.85,4.85,0,0,0,3.48-1.47,3.65,3.65,0,0,0-7,0A4.85,4.85,0,0,0,8.91,26Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingIcon);
export default __webpack_public_path__ + "static/media/tracking_icon.46aceafed7576e5396a8f9028784eabc.svg";
export { ForwardRef as ReactComponent };